import { Component } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { CmUiStandardButtonComponent } from '@cm/ui-modules';

@Component({
  selector: 'app-backend-error',
  standalone: true,
  imports: [MatIconModule, CmUiStandardButtonComponent],
  templateUrl: './backend-error.component.html',
  styleUrls: ['./backend-error.component.scss'],
})
export class BackendErrorComponent {
  refreshPage(): void {
    window.location.reload();
  }
}
